'use-strict';

import { $, throttle } from '../helper/utils';

export const init = () => {
    const innerHeight = window.innerHeight;
    const backToTop = $('.back-to-top');
    const backTopTween = TweenMax.fromTo(backToTop, .6, {
        scale: 0,
        y: 50,
    }, {
        y: 0,
        scale: 1,
        opacity: 1,
        pointerEvents: 'auto',
        paused: true,
        ease: Elastic.easeOut.config(1, 0.6)
    });
    let lastScrolls = [];

    window.addEventListener('scroll', throttle(inView, 300));

    function inView() {
        const top = window.pageYOffset || document.documentElement.scrollTop;

        // need at last 3 scrolls
        if (lastScrolls.length < 3) {
            lastScrolls.push(top);
            return;
        }

        const scrolls = lastScrolls.slice(0, lastScrolls.length);

        // -1 up, 1 down
        const directions = scrolls.map(m => {
            return top < m ? -1 : 1;
        });

        if (top >= innerHeight) {
            // scroll down hide button
            if (directions.indexOf(1) !== -1) {
                backTopTween.reverse();

                // scroll up show button
            } else {
                backTopTween.play();
            }
        } else {
            backTopTween.reverse();
        }

        lastScrolls = [];
    }
};